import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "invertedContent", "hiddenValue"];

  toggle(event) {
    const checked = event.target.checked;
    this.contentTargets.forEach((el) => el.classList.toggle("hidden", !checked));
    this.invertedContentTargets.forEach((el) => {
      el.classList.toggle("hidden", checked);
      el.disabled = checked;
    });
  }

  // For switch components where "checked" (enabled) means the content should be hidden
  // e.g. "Checkout Form Enabled" switch: checked = enabled = hide disabled message
  toggleSwitch(event) {
    const enabled = event.target.value === "true";
    if (this.hasHiddenValueTarget) {
      this.hiddenValueTarget.value = enabled ? "false" : "true";
    }
    // Show content when disabled (switch unchecked)
    this.contentTargets.forEach((el) => el.classList.toggle("hidden", enabled));
    this.invertedContentTargets.forEach((el) => {
      el.classList.toggle("hidden", !enabled);
      el.disabled = !enabled;
    });
  }
}
